import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { BusinessDefaultProductDeleteCard } from './components/DefaultProductDeleteCard';
import { BusinessDefaultProductDetailsCard } from './components/DefaultProductDetailsCard';

export function BusinessDefaultProductDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const businessDefaultProductQueryResults = useQuery({
        queryKey: ['businessDefaultProduct', id],
        queryFn: () =>
            Api.BusinessSpecific.DefaultProduct.getDefaultProduct(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={businessDefaultProductQueryResults}>
                {data => (
                    <Stack gap={2} sx={{ paddingBottom: 4 }}>
                        <BusinessDefaultProductDetailsCard
                            businessDefaultProduct={data}
                        />

                        <Can I="delete" a="BusinessDefaultProduct">
                            <BusinessDefaultProductDeleteCard
                                businessDefaultProduct={data}
                            />
                        </Can>
                    </Stack>
                )}
            </QueryRenderer>
        </RootContainer>
    );
}
